import {ModuleWithProviders, NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EarningComponent } from './earning/earning.component';
import { LinksComponent } from './links/links.component';
import { ProductsComponent } from './products/products.component';
import {AffiliateComponent} from "./affiliate.component";
import {SignUpComponent} from "./sign-up/sign-up.component";
import {UserKycComponent} from "./user-kyc/user-kyc.component";
import {ReferralComponent} from "./referral/referral.component";

/**
 * Created by Aman Gupta on 28-07-2025.
 */
const router: Routes = [
  {
    path: 'associates',
    component: AffiliateComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent, data: { headerHeading: 'Dashboard' } },
      { path: 'earning', component: EarningComponent, data: { headerHeading: 'Earnings' } },
      { path: 'links', component: LinksComponent, data: { headerHeading: 'Links' } },
      { path: 'products', component: ProductsComponent, data: { headerHeading: 'Products' } },
      { path: 'kyc', component: UserKycComponent, data: { headerHeading: 'KYC' } },
      { path: 'referral', component: ReferralComponent, data: { headerHeading: 'Referral' } },
    ],
  },
  { path: 'associates/register', component: SignUpComponent, data: { headerHeading: 'Register' } }
];



export const routing: ModuleWithProviders<any> = RouterModule.forChild(router);
